import { invokeRPC } from './socket.js'

export function getUploadUserPhotoToken(id) {
  return invokeRPC('user', 'getUserPhotoUploadToken', { id })
}

export const getUserData = (data) => {
  return invokeRPC('user', 'getUserData', data)
}

export const getUserList = () => {
  return invokeRPC('user', 'getUserList')
}

export const createAdmin = (data) => {
  return invokeRPC('user', 'createAdmin', data)
}

export const deleteUser = (id) => {
  return invokeRPC('user', 'deleteUser', { id })
}

export const createUserForCustomer = (data) => {
  return invokeRPC('user', 'createUserForCustomer', data)
}

export const changeDisabled = (data) => {
  return invokeRPC('user', 'changeDisabled', data)
}

export const changePassword = (data) => {
  return invokeRPC('user', 'changePassword', data)
}

export const updateUser = (data) => {
  return invokeRPC('user', 'updateUser', data)
}

export const getStatus = (data) => {
  return invokeRPC('user', 'getStatus', data)
}

export const getLastLogin = (data) => {
  return invokeRPC('user', 'getLastLogin', data)
}

export const getPersonalLastLogin = (data) => {
  return invokeRPC('user', 'getPersonalLastLogin', data)
}

export const getHistory = (data) => {
  return invokeRPC('user', 'getHistory', data)
}

export const getHistoryCount = (data) => {
  return invokeRPC('user', 'getHistoryCount', data)
}

export const initiatePasswordReset = (userId) => {
  return invokeRPC('user', 'initiatePasswordReset', {
    user_id: userId,
    origin: window.location.origin
  })
}

export function deleteUserPhoto(userId) {
  return invokeRPC('user', 'deleteUserPhoto', { id: userId })
}

export function getUserAbilities(userId) {
  return invokeRPC('user', 'getUserAbilities', { id: userId })
}

export function toggleMaintenanceNotify(data) {
  return invokeRPC('user', 'toggleMaintenanceNotify', data)
}

export const checkMaintenanceNotify = (userId) => {
  return invokeRPC('user', 'checkMaintenanceNotify', { id: userId })
}

export function sendMaintenanceStartingEmail(data) {
  return invokeRPC('user', 'sendMaintenanceStartingEmail', data)
}

export function sendMaintenanceFinishEmail(data) {
  return invokeRPC('user', 'sendMaintenanceFinishEmail', data)
}

export function getAllActiveAdmins() {
  return invokeRPC('user', 'getAllActiveAdmins')
}

export function getAssignedAnalysts(customerId) {
  return invokeRPC('user', 'getAssignedAnalysts', { customer_id: customerId })
}